import cn from 'classnames';
import React, { FC, memo, useMemo } from 'react';

import { ButtonGroup } from '@mui/material';

import { Option } from '@app-types/common/common.types';

import FilterTab from './FilterTab';
import useStyles from './styles.module';

interface Props {
  className?: string;
  onClick: (value: string | number) => void;
  selectedValues: (string | number)[] | string | undefined;
  options: Option[];
  disabled?: boolean;
}

const FilterTabs: FC<Props> = ({
  className,
  onClick,
  selectedValues,
  options,
  disabled = false,
}) => {
  const { classes } = useStyles();

  const isSelectedAll = useMemo(
    () =>
      options.every(
        (option) =>
          selectedValues &&
          Array.isArray(selectedValues) &&
          [...selectedValues].includes(option.value),
      ),
    [options, selectedValues],
  );

  return (
    <ButtonGroup
      variant="contained"
      className={cn(classes.buttonGroup, className)}
      disabled={disabled}
    >
      {options.map((option) => {
        const isActive = Array.isArray(selectedValues)
          ? selectedValues.includes(option.value) && !isSelectedAll
          : selectedValues === option.value;

        return (
          <FilterTab
            {...option}
            key={option.label}
            isActive={isActive}
            onClickTab={onClick}
            disabled={disabled}
          />
        );
      })}
    </ButtonGroup>
  );
};

export default memo(FilterTabs);
